const hasRollbarToken = !!import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN;

const rollbarConfig = {
  accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
  environment:
    import.meta.env.VITE_ROLLBAR_ENVIRONMENT ||
    import.meta.env.MODE ||
    "development",
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        // MUST match the version you use when uploading sourcemaps
        code_version: import.meta.env.VITE_APP_VERSION || "dev",

        // optional but recommended
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
};

export { rollbarConfig, hasRollbarToken };
